import modify from './modify.vue'

export default modify
